import palette from "../colors/dark-theme";

const { text } = palette;

const MuiAlert: any = {
  styleOverrides: {
    root: {
      color: text.primary,
    },
  },
};

export default MuiAlert;
